const {siteObj: utils} = window;
utils.fn = {
  // Returns query string parameters from a URL as a JS object. Although this is
  // specifically for URLs it also can be used on any string with "?name=val&name=val" notation.
  getURIParams(str) {
    const map = {};
    str.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      map[key] = value;
    });
    return map;
  },
  
  // Returns a specific parameter from a set of query string parameters.
  getURIParam(str, param) {
    // FIXME - usages of this cause getURIParams to execute EVERY TIME, which is very inefficient
    // Convert query string param to object.
    const obj = this.getURIParams(str);
    return obj.hasOwnProperty(param) ? obj[param] : false; // Returns false if param isn't present.
  },
  
  // Gets a specific cookie.
  getCookie(name) {
    const cookies = document.cookie;
    let start;
    let end;
    let ret = null;
  
    if (cookies.length > 0) {
      start = cookies.indexOf(`${name}=`);
    
      if (start !== -1) {
        start = start + name.length + 1;
        end = cookies.indexOf(';', start);
      
        if (end === -1) {
          end = cookies.length;
        }
        ret = unescape(cookies.substring(start, end));
      }
    }
    return ret;
  },
};

export default utils;
